import * as React from "react"
import { Helmet } from "react-helmet"
import Navigation from './components/base/Navigation';
import Footer from './components/base/Footer';

import "./css/bootstrap.css"
import "./css/stack-interface.css"
import "./css/socicon.css"
import "./css/lightbox.min.css"
import "./css/flickity.css"
import "./css/iconsmind.css"
import "./css/theme.css"
import "./css/custom.css"


// markup
class BaseController extends React.Component {
  render() {
    return (
      <div className="base">
        <Helmet>
          <meta charset="utf-8" />
          <title>Popupfox | No-Code Popup and Form Builder for your business</title>
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <meta name="description" content="Site Description Here" />
          <link href="https://fonts.googleapis.com/css?family=Inter:200,300,400,400i,500,600,800,700%7CMerriweather:300,300i" rel="stylesheet" />
          <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet" />
        </Helmet>
        <Navigation />
        {this.props.children}
        <Footer />
      </div>
    )
  }
}

export default BaseController